const THEME_STORAGE_KEY = 'rp.theme'

export const THEME_PREFERENCES = ['system', 'light', 'dark'] as const
export type ThemePreference = (typeof THEME_PREFERENCES)[number]

const isPreference = (value: unknown): value is ThemePreference =>
  typeof value === 'string' && (THEME_PREFERENCES as readonly string[]).includes(value)

export const readThemePreference = (storage: Pick<Storage, 'getItem'>): ThemePreference => {
  try {
    const stored = storage.getItem(THEME_STORAGE_KEY)
    return isPreference(stored) ? stored : 'system'
  } catch {
    return 'system'
  }
}

export const storeThemePreference = (storage: Pick<Storage, 'setItem'>, preference: ThemePreference): void => {
  try {
    storage.setItem(THEME_STORAGE_KEY, preference)
  } catch {
    return
  }
}

export const applyTheme = (root: { dataset: DOMStringMap }, preference: ThemePreference): void => {
  if (preference === 'system') {
    delete root.dataset.theme
    return
  }
  root.dataset.theme = preference
}
